import httpClient from "./httpClient";
const vueAppLocaleUrl =  'api/v2/locale/fr/json';
const localeService = {
 
  getJson() {
    return httpClient.get(vueAppLocaleUrl, {params: {appName:2}});
  },
};

export default localeService;
